import {
  AudienceComparisonParams,
  AudienceComparisonResult,
  AudienceOptionItem,
  AudienceOptions,
  AudienceSourcesFromApi,
} from "../types/audience-compare";

import { API } from "./api";
import baselines from "../consts/baselines";
import geoSegments from "../consts/geo-segments.json";
import { relativeDateToDateRange } from "../utils/date";

const accountsAPI = "/api/1/accounts";
const audienceLensApi = "/api/1/audience-lens";

const getAudienceSources = async (
  accountId: number,
): Promise<AudienceOptions> => {
  const res = await API.get<AudienceSourcesFromApi>(
    `${accountsAPI}/${accountId}/network-filters`,
  );

  const { networks, accounts } = res.data;

  return [
    {
      group: "Networks",
      items: networks.map((x) => ({
        value: x.id,
        label: x.name,
        type: "network",
      })),
    },
    {
      group: "Accounts",
      items: accounts.map((x) => ({
        value: x.id,
        label: x.name,
        type: "network",
      })),
    },
    ...geoSegments.sections.map((section) => ({
      group: section.label,
      items: section.segments.map(
        (x): AudienceOptionItem => ({
          value: x.id,
          label: x.name,
          type: "segment",
          weighting: x.weighting ?? undefined,
        }),
      ),
    })),
  ];
};

const getAudienceSettingOptions = async (accountId: number) => {
  const sources = await getAudienceSources(accountId);

  return { sources, baselines };
};

const getAudienceComparisonRow = async ({
  dateFilter,
  ...params
}: AudienceComparisonParams): Promise<AudienceComparisonResult> => {
  const res = await API.get(`${audienceLensApi}/row`, {
    params: {
      ...params,
      ...relativeDateToDateRange(dateFilter),
    },
  });
  return res.data;
};

export default {
  getAudienceSources,
  getAudienceSettingOptions,
  getAudienceComparisonRow,
};
